import { Module } from "vuex";
import { RootState } from "@/store/types";
import { IncomingTariffsState } from "./types";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

export const state: IncomingTariffsState = {
  incomingTariffs: [],
};

export const incomingTariffs: Module<IncomingTariffsState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};
